import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

export default function AppInput({
  value,
  onChange = () => {},
  onBlur = () => {},
  onKeyDown = () => {},
  placeholder,
  style,
  className,
  type,
  size,
  color,
  radius,
  variant,
  shadow,
  removeWrapper = false,
  label,
  disabled,
  min,
  max,
  maxLength,
  defaultTime = false,
  minDate = "00:00",
  maxDate = "23:59",
  isMin = false,
  isMax = false,
}) {
  const inputStyles =
    type === "number"
      ? {
          ...style,
          MozAppearance: "textfield",
        }
      : style;

  const handleClick = (e) => {
    debugger;
    // Only do this if datetime-local, defaultTime is true, and value exists
    if (type === "datetime-local" && defaultTime && value) {
      const currentDateTime = new Date(value);
      if (!isNaN(currentDateTime)) {
        const year = currentDateTime.getFullYear();
        const month = String(currentDateTime.getMonth() + 1).padStart(2, "0");
        const day = String(currentDateTime.getDate()).padStart(2, "0");

        let timePart = "00:00"; // default

        if (isMin) {
          timePart = minDate; // Use given minDate
        } else if (isMax) {
          timePart = maxDate; // Use given maxDate
        }

        const combinedDateTime = `${year}-${month}-${day}T${timePart}`;

        // Update the value
        onChange(combinedDateTime);
      }
    }
  };

  return (
    <div className={className}>
      <div className="flex justify-between">
        <style>
          {`
          input[type="number"]::-webkit-outer-spin-button,
          input[type="number"]::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
        `}
        </style>
        {label && (
          <Label className="mb-2" htmlFor="inputId">
            {label}
          </Label>
        )}
      </div>
      <Input
        value={value || ""}
        onClick={handleClick} // important
        onChange={(e) => onChange(e.target.value)}
        onBlur={(e) => onBlur(e.target.value)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        style={style}
        // className={className}
        type={type}
        size={size}
        color={color}
        radius={radius}
        variant={variant}
        shadow={shadow}
        removeWrapper={removeWrapper}
        disabled={disabled}
        min={min}
        max={max}
        maxLength={maxLength}
      />
    </div>
  );
}
